<template>
  <VDialogV3
    ref="dialog"
    position="center"
    width="500px"
    :entity="contract"
    :submit-method="publish"
  >
    <section>
      <VDateInput
        v-model="publicationDate"
        label="Дата публикации и вступления в силу"
        layout="vertical"
        required
        :validate-method="validatePublicationDate"
      />
    </section>

    <VHelperText>
      <b>Внимание!</b> После нажатия на кнопку "Опубликовать" внесение изменений невозможно
    </VHelperText>

    <template #footer>
      <VButton
        theme="primary"
        @click="$refs.dialog.submit()"
      >
        Опубликовать
      </VButton>
      <VButton @click="$refs.dialog.close()">
        Отмена
      </VButton>
    </template>
  </VDialogV3>
</template>

<script lang="ts">

import ContractsPublicService from '@/domains/Contracts/ContractsPublicService';
import ContractPublic         from '@/domains/Contracts/ContractPublic';

export default defineComponent({
	name: 'ContractPublicationDialog',

	props: {
		contract: {
			type:    Object as PropType<ContractPublic>,
			default: null,
		},
	},

	data() {
		return {
			publicationDate: null as Date | null,
			contracts:       [] as ContractPublic[],
		};
	},

	computed: {
		contractsVersionList(): string[] {
			return this.contracts.map(item => item.version.toString())
				.filter(item => item !== '0');
		},
	},

	mounted() {
		this.loadContracts();
	},

	methods: {
		async loadContracts(): Promise<void> {
			this.contracts = await ContractsPublicService.getList(
				{ id: this.contract.type.id } as ContractPublic['type'],
			);
		},

		/** Публикует договор. Валидацию формы и resolve() при успехе делает VDialogV3. */
		async publish(): Promise<boolean> {
			return await ContractsPublicService.publish(
				{ id: this.contract.type.id } as ContractPublic['type'],
				this.publicationDate,
			);
		},

		validatePublicationDate(value: Date): string | null {
			if (value instanceof Date === false) {
				return null;
			}

			let versionString = value.getFullYear().toString();

			versionString += value.getMonth() < 9 ? `0${value.getMonth() + 1}` : value.getMonth() + 1;
			versionString += value.getDate() < 10 ? `0${value.getDate()}` : value.getDate();

			if (this.contractsVersionList.includes(versionString)) {
				return 'На эту дату уже опубликован договор';
			}

			return null;
		},
	},
});
</script>